export default function ContactSection() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      body.append(key, value.toString());
    });

    try {
      const res = await fetch("https://readdy.ai/api/form/d7ibm6haljjjkv6jgnc0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      if (res.ok) {
        const successEl = document.getElementById("form-success");
        if (successEl) {
          successEl.classList.remove("hidden");
          form.reset();
          setTimeout(() => successEl.classList.add("hidden"), 5000);
        }
      }
    } catch {
      // silent
    }
  };

  return (
    <section id="contact" className="py-12 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-0 rounded-2xl overflow-hidden border border-gray-100">
          {/* Left: Image + text */}
          <div className="relative w-full lg:w-1/2 min-h-[280px] md:min-h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=completed%20waterproofing%20project%20on%20modern%20building%20rooftop%2C%20professional%20etancheite%20result%2C%20clean%20flat%20roof%20with%20drainage%20system%2C%20urban%20environment%2C%20bright%20daylight%2C%20impressive%20professional%20finish%2C%20green%20rooftop&width=700&height=600&seq=ksbtp-contact-etanche001&orientation=portrait"
              alt="Contactez KS BTP Étanchéité"
              className="w-full h-full object-cover object-top absolute inset-0"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#007a30]/80 via-[#00a340]/60 to-[#007a30]/80"></div>
            <div className="relative z-10 p-6 md:p-10 flex flex-col justify-between h-full min-h-[280px] md:min-h-[400px]">
              <div>
                <span className="text-xs text-green-200 uppercase tracking-widest font-bold">Demander un devis étanchéité</span>
                <h2 className="text-2xl md:text-4xl font-extrabold text-white mt-2 mb-3 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  Votre projet d&apos;étanchéité entre de bonnes mains
                </h2>
                <p className="text-green-100 text-sm leading-relaxed max-w-sm text-justify">
                  Contactez-nous pour un devis gratuit et sans engagement. Nos experts étudient votre ouvrage et vous proposent la meilleure solution d&apos;étanchéité adaptée à vos contraintes.
                </p>
              </div>
              <div className="mt-6 md:mt-10 flex flex-col gap-3">
                {[
                  { icon: "ri-phone-line", text: "01 75 43 43 46", href: "tel:0175434346" },
                  { icon: "ri-mail-line", text: "contact@ksbtp.fr", href: "mailto:contact@ksbtp.fr" },
                  { icon: "ri-map-pin-line", text: "9 rue de Lamirault, 77090 Collégien", href: "https://maps.google.com/?q=9+rue+de+Lamirault+77090+Collegien" },
                  { icon: "ri-time-line", text: "Lun–Jeu : 8h30–17h30 | Ven : 8h30–12h30", href: null },
                ].map((item) => (
                  item.href ? (
                    <a key={item.text} href={item.href} target={item.href.startsWith("http") ? "_blank" : undefined} rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined} className="flex items-center gap-3 hover:opacity-80 transition-opacity cursor-pointer">
                      <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 text-white flex-shrink-0">
                        <i className={`${item.icon} text-sm`}></i>
                      </div>
                      <span className="text-green-100 text-sm">{item.text}</span>
                    </a>
                  ) : (
                    <div key={item.text} className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 text-white flex-shrink-0">
                        <i className={`${item.icon} text-sm`}></i>
                      </div>
                      <span className="text-green-100 text-sm">{item.text}</span>
                    </div>
                  )
                ))}
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <div className="w-full lg:w-1/2 bg-[#f5fdf8] p-6 md:p-10">
            <h3 className="text-lg md:text-xl font-extrabold text-gray-900 mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Demande de devis étanchéité gratuit
            </h3>
            <p className="text-gray-500 text-sm mb-5 md:mb-8">Remplissez le formulaire, nous vous recontactons sous 24h.</p>

            <div id="form-success" className="hidden mb-5 p-4 rounded-xl bg-[#e6f7ed] border border-[#a8f0c0] text-[#00a340] text-sm font-medium">
              <i className="ri-checkbox-circle-line mr-2"></i>
              Votre demande a bien été envoyée. Nous vous recontacterons dans les plus brefs délais.
            </div>

            <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-3 md:gap-4">
              <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
                <div className="flex-1">
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Prénom *</label>
                  <input
                    type="text"
                    name="prenom"
                    required
                    placeholder="Jean"
                    className="w-full px-4 py-2.5 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors"
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Nom *</label>
                  <input
                    type="text"
                    name="nom"
                    required
                    placeholder="Dupont"
                    className="w-full px-4 py-2.5 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors"
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">Email *</label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="jean.dupont@email.fr"
                  className="w-full px-4 py-2.5 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors"
                />
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">Téléphone *</label>
                <input
                  type="tel"
                  name="telephone"
                  required
                  placeholder="+33 6 XX XX XX XX"
                  className="w-full px-4 py-2.5 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors"
                />
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">Type de travaux d&apos;étanchéité</label>
                <select
                  name="type_travaux"
                  className="w-full px-4 py-2.5 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors cursor-pointer"
                >
                  <option value="">Sélectionnez le type de travaux</option>
                  <option value="toiture_terrasse">Toiture-terrasse</option>
                  <option value="parking">Parking (enrobés & asphalte)</option>
                  <option value="dalle_carrossable">Dalle carrossable</option>
                  <option value="terrasse">Terrasse</option>
                  <option value="etancheite_isolation">Étanchéité + isolation thermique</option>
                  <option value="refection">Réfection étanchéité existante</option>
                  <option value="autre">Autre</option>
                </select>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">Description du projet</label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  placeholder="Décrivez votre projet d'étanchéité : type d'ouvrage, surface approximative, localisation, délais souhaités..."
                  className="w-full px-4 py-2.5 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors resize-none"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full py-3 rounded-lg bg-[#00a340] text-white font-bold text-sm whitespace-nowrap hover:bg-[#007a30] transition-colors cursor-pointer"
              >
                Envoyer ma demande de devis
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
